import Guard from './middleware'
import DashboardLayout from 'src/pages/Dashboard/Layout/DashboardLayout.vue'
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
import Online from 'src/pages/Dashboard/Online/Online.vue'
import OnlineDetails from 'src/pages/Dashboard/Online/OnlineDetails.vue'
import OnlineTickets from 'src/pages/Dashboard/Online/OnlineTickets.vue'
import OnlineProducts from 'src/pages/Dashboard/Online/OnlineProducts.vue'
import Login from 'src/pages/GeneralViews/Login.vue'
import ServerDown from 'src/pages/GeneralViews/ServerDown.vue'
import Informes from './informes'
import Configuracion from './configuracion'
import SoporteOnline from 'src/pages/Dashboard/SoporteOnline/SoporteOnline.vue'
import SoporteOnlineForm from 'src/pages/Widgets/SoporteOnline/SoporteOnlineForm.vue'
import Permisos from 'src/pages/Dashboard/Permisos/Permisos.vue'
import GestionGastos from 'src/pages/Dashboard/Gastos/GestionGastos.vue'
import GestionGasto from 'src/pages/Dashboard/Gastos/GestionGasto.vue'
import Almacen from 'src/pages/Dashboard/Almacen/Almacen.vue'
import HistorialAlmacen from 'src/pages/Dashboard/Almacen/HistoricoAlmacen.vue'
import DetallesAlmacen from 'src/pages/Dashboard/Almacen/DetallesAlmacen.vue'
import DetalleSubproductoAlmacen from 'src/pages/Dashboard/Almacen/DetalleSubproductoAlmacen.vue'
import PedidosProveedor from 'src/pages/Dashboard/PedidosProveedor/PedidosProveedor.vue'
import PedidoProveedor from 'src/pages/Dashboard/PedidosProveedor/PedidoProveedor.vue'
import PosicionGlobal from 'src/pages/Dashboard/PosicionGlobal/PosicionGlobal.vue'
import Plano from 'src/pages/Dashboard/Online/OnlinePlano.vue'
import CajonInteligente from 'src/pages/Dashboard/Online/OnlineCajonInteligente.vue'
import Perfil from 'src/pages/Dashboard/Perfil/Perfil.vue'
import Novedades from 'src/pages/Dashboard/Novedades/Novedades.vue'
import DetalleNovedades from 'src/pages/Dashboard/Novedades/DetalleNovedades.vue'
import Terms from 'src/pages/GeneralViews/Terms.vue'
import RememberPass from 'src/pages/GeneralViews/RememberPass.vue'
import Calendar from 'src/pages/Dashboard/RegistroHorarios/Calendar.vue'
import RecursosClientes from 'src/pages/Dashboard/Recursos/RecursosClientes.vue'
import Camaras from 'src/pages/Dashboard/Camaras/Camaras.vue'
import Delivery from 'src/pages/Dashboard/Delivery/Delivery.vue'
import ProductosCarta from 'src/pages/Dashboard/Delivery/Configuracion/Productos/ProductosCarta.vue'
import MenusCarta from 'src/pages/Dashboard/Delivery/Configuracion/Menus/MenusCarta.vue'
import InformacionCarta from 'src/pages/Dashboard/Delivery/Configuracion/InformacionCarta/InformacionCarta.vue'
import ProductoCarta from 'src/pages/Dashboard/Delivery/Configuracion/Productos/ProductoCarta.vue'
import MenuCarta from 'src/pages/Dashboard/Delivery/Configuracion/Menus/MenuCarta.vue'
import CategoriasCarta from 'src/pages/Dashboard/Delivery/Configuracion/Categorias/CategoriasCarta.vue'
import CategoriaCarta from 'src/pages/Dashboard/Delivery/Configuracion/Categorias/CategoriaCarta.vue'
import ConfiguracionCarta from 'src/pages/Dashboard/Delivery/Configuracion/ConfiguracionCarta.vue'
import FormasPagoCarta from 'src/pages/Dashboard/Delivery/Configuracion/FormasPago/FormasPagoCarta.vue'
import GuiaUsuario from 'src/pages/Dashboard/Delivery/Configuracion/GuiaUsuario/GuiaUsuario.vue'
import ConfiguracionHorarios from 'src/pages/Dashboard/Delivery/Configuracion/Horarios/ConfiguracionHorarios.vue'
import RestriccionHorarios from 'src/pages/Dashboard/Delivery/Configuracion/Horarios/RestriccionHorarios.vue'
import ZonasCarta from 'src/pages/Dashboard/Delivery/Configuracion/Zonas/ZonasCarta.vue'
import FormaPagoCarta from 'src/pages/Dashboard/Delivery/Configuracion/FormasPago/FormaPagoCarta.vue'
import MateriasPrimasCarta from 'src/pages/Dashboard/Delivery/Configuracion/MateriasPrimas/MateriasPrimasCarta.vue'
import MateriaPrimaCarta from 'src/pages/Dashboard/Delivery/Configuracion/MateriasPrimas/MateriaPrimaCarta.vue'
import RestriccionesProductos from 'src/pages/Dashboard/Delivery/Configuracion/Productos/RestriccionesProducto.vue'
import PersonalizarCarta from 'src/pages/Dashboard/Delivery/Configuracion/Personalizacion/PersonalizarCarta.vue'
import IdiomasCarta from 'src/pages/Dashboard/Delivery/Configuracion/Idiomas/IdiomasCarta.vue'
import DiagnosticoCarta from 'src/pages/Dashboard/Delivery/Configuracion/Diagnostico/DiagnosticoCarta.vue'
import KioskosCarta from 'src/pages/Dashboard/Delivery/Configuracion/Kioskos/KioskosCarta.vue'
import EntradaAlmacen from 'src/pages/Dashboard/GestionAlmacen/EntradaAlmacen.vue'
import ImportacionExcels from 'src/pages/Dashboard/Importacion/ImportacionExcels.vue'
import ControlInventario from 'src/pages/Dashboard/GestionAlmacen/ControlInventario.vue'
import Inventario from 'src/pages/Dashboard/GestionAlmacen/Inventario.vue'
import Integraciones from 'src/pages/Dashboard/Integraciones/Integraciones.vue'
import GStock from 'src/pages/Dashboard/Integraciones/G-Stock/G-Stock.vue'
import Cheerfy from 'src/pages/Dashboard/Integraciones/Cheerfy/Cheerfy.vue'
import ProductosNoRelacionados from 'src/pages/Dashboard/Integraciones/ProductosNoRelacionados/ProductosNoRelacionados.vue'
import BusinessCentral from 'src/pages/Dashboard/Integraciones/BusinessCentral/BusinessCentral.vue'
import ProductosBusinessCentral from 'src/pages/Dashboard/Integraciones/BusinessCentral/Productos/ProductosBusinessCentral.vue'
import MateriasPrimasBusinessCentral from '../pages/Dashboard/Integraciones/BusinessCentral/MateriasPrimas/MateriasPrimasBusinessCentral.vue'
import FormasDePagoBusinessCentral from '../pages/Dashboard/Integraciones/BusinessCentral/FormasDePago/FormasDePagoBusinessCentral.vue'
import ExportacionVentasBusinessCentral from '../pages/Dashboard/Integraciones/BusinessCentral/ExportacionVentas/ExportacionVentasBusinessCentral.vue'
import Log from 'src/pages/Dashboard/Log/Log.vue'
import PlanificadorCarta from 'src/pages/Dashboard/Delivery/Configuracion/PlanificacionCarta/PlanificadorCarta.vue'
import PlanificacionCarta from 'src/pages/Dashboard/Delivery/Configuracion/PlanificacionCarta/PlanificacionCarta.vue'
import ListadoTicketRepartidor from 'src/pages/Dashboard/Informes/Pedidos/ListadoTicketRepartidor.vue';
import GastosPerdidos from '../pages/Dashboard/Informes/GastosPerdidos/GastosPerdidos.vue'
import ListadoMateriaPrimaProveedor from '../pages/Dashboard/Configuracion/Proveedores/ListadoSubProductProveedor.vue'
import ProductoForm from 'src/pages/Widgets/Productos/ProductoForm.vue'
import SubproductForm from 'src/pages/Widgets/Subproductos/SubproductoForm.vue'
import TurnosOperariosExternalLink from 'src/pages/Dashboard/Informes/Operarios/TurnosOperariosExternalLink.vue'
import diagnosticoPLU from 'src/pages/Dashboard/Integraciones/DiagnosticoPLU/diagnosticoPLU.vue'
import HerramientrasGestion from 'src/pages/Dashboard/Configuracion/Herramientas/HerramientasGestion.vue'
import Herramientas from 'src/pages/Dashboard/Configuracion/Herramientas/Herramientas.vue'
import { Form } from 'element-ui'
import VerifactuDashboard from '../pages/Dashboard/Verifactu/VerifactuDashboard.vue'
import DowngradesBusinessCentral from '../pages/Dashboard/Integraciones/BusinessCentral/Downgrades/DowngradesBusinessCentral.vue'


let perfil = {
    path: '/perfil',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/perfil/',
            name: 'perfil',
            component: Perfil
        },
    ]
};

let soporteOnlineMenu = {
    path: '/soporte-online',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/soporte-online/:pag?',
            name: 'soporte-online',
            component: SoporteOnline
        },
        {
            path: '/soporte-online-det/:idTicket',
            name: 'soporte-online-ticket',
            component: SoporteOnlineForm
        },
    ]
};

let recursosClientes = {
    path: '/recursos',
    component: RecursosClientes,
    children: [
        {
            path: '/recursos-numier/:idRecurso?',
            name: 'recursoCliente',
            component: RecursosClientes
        }
    ]
}

let gestionAlmacen = {
    path: '/gestion-almacen',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/entrada-almacen/',
            name: 'entrada-almacen',
            component: EntradaAlmacen
        },
        {
            path: '/entrada-almacen/:idBusiness/:idMovimiento',
            name: 'editar-entrada-almacen',
            component: EntradaAlmacen
        },
        {
            path: '/control-inventario/:idBusiness',
            name: 'control-inventario',
            component: ControlInventario
        }
    ]
};

let inventario = {
    path: '/inventario/:query',
    name: 'inventario',
    component: Inventario
}

/*<let camaras = {
    path: '/camaras',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/camaras/',
            name: 'camaras',
            component: Camaras
        }
    ]
};*/


let gastos = {
    path: '/gastos',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/gestion-gastos/',
            name: 'gestion-gastos',
            component: GestionGastos
        },
        {
            path: '/gestion-gasto/:idBusiness/:idGasto?',
            name: 'gestion-gasto',
            component: GestionGasto
        },
        {
            path: '/ajustes-gastos',
            name: 'ajustes-gastos',
            component: GastosPerdidos
        }
    ]
};


//* sirve para las rutas momentáneas de Selfibar.
let selfibar = {
    path: '/guia-usuario/',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/',
            name: 'guia-usuario',
            component: GuiaUsuario
        },
    ]
};

let delivery = {
    path: '/delivery',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/delivery/',
            name: 'delivery',
            component: Delivery
        },
        {
            path: '/productos-carta/',
            name: 'productos-carta',
            component: ProductosCarta
        },
        {
            path: '/categorias-carta/',
            name: 'categorias-carta',
            component: CategoriasCarta
        },
        {
            path: '/categoria-carta/:idBusiness/:idCategoria?',
            name: 'categoria-carta',
            component: CategoriaCarta
        },
        {
            path: '/producto-carta/:idBusiness/:idCarta/:idProducto?',
            name: 'producto-carta',
            component: ProductoCarta
        },
        {
            path: '/informacion-carta/',
            name: 'informacion-carta',
            component: InformacionCarta
        },
        {
            path: '/configuracion-carta/',
            name: 'configuracion-carta',
            component: ConfiguracionCarta
        },
        {
            path: '/formas-de-pago-carta/',
            name: 'formas-de-pago-carta',
            component: FormasPagoCarta
        },
        {
            path: '/forma-de-pago-carta/:idBusiness/:idFormaPago?',
            name: 'forma-de-pago-carta',
            component: FormaPagoCarta
        },
        {
            path: '/materias-primas-carta/',
            name: 'materias-primas-carta',
            component: MateriasPrimasCarta
        },
        {
            path: '/materia-prima-carta/:idBusiness/:idMateriaPrima?',
            name: 'materia-prima-carta',
            component: MateriaPrimaCarta
        },

        {
            path: '/menus-carta/',
            name: 'menus-carta',
            component: MenusCarta
        },
        {
            path: '/menu-carta/:idBusiness/:idCarta/:idMenu?',
            name: 'menu-carta',
            component: MenuCarta
        },
        {
            path: '/planificador-carta/',
            name: 'planificador-carta',
            component: PlanificadorCarta
        },
        {
            path: '/planificacion-carta/',
            name: 'planificacion-carta',
            component: PlanificacionCarta
        },
        {
            path: '/horarios-carta/',
            name: 'horarios-carta',
            component: ConfiguracionHorarios
        },
        {
            path: '/restriccion-horarios/',
            name: 'restriccion-horarios',
            component: RestriccionHorarios
        },
        {
            path: '/restricciones-productos/',
            name: 'restricciones-productos',
            component: RestriccionesProductos
        },
        {
            path: '/zonas-carta/',
            name: 'zonas-carta',
            component: ZonasCarta
        },
        {
            path: '/configuracion-horarios/',
            name: 'zonascarta',
            component: FormasPagoCarta
        },
        {
            path: '/personalizar-carta/',
            name: 'personalizar-carta',
            component: PersonalizarCarta
        },
        {
            path: '/idiomas-carta/',
            name: 'idiomas-carta',
            component: IdiomasCarta
        },
        {
            path: '/diagnostico-carta/',
            name: 'diagnostico-carta',
            component: DiagnosticoCarta
        },
        {
            path: '/kioskos-carta',
            name: 'kioskos-carta',
            component: KioskosCarta
        },
        {
            path: '/materias-primas-proveedor/:idProveedor?',
            name: 'listado-materia-prima-proveedor',
            component: ListadoMateriaPrimaProveedor
        },


    ]
};

let posicionGlobal = {
    path: '/posicion-global',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/posicion-global/',
            name: 'posicion-global',
            component: PosicionGlobal
        },

    ]
};

let pedidosProveedor = {
    path: '/pedidos',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/pedidos-proveedor/',
            name: 'pedidos-proveedor',
            component: PedidosProveedor
        },
        {
            path: '/pedido-proveedor/',
            name: 'pedido-proveedor',
            component: PedidoProveedor
        },
        {
            path: '/listado-ticket-repartidor/',
            name: 'listado-ticket-repartidor',
            component: ListadoTicketRepartidor,
            props: route => ({
                idRepartidor: route.params.idRepartidor,
                datefrom: route.params.datefrom,
                dateto: route.params.dateto,
            })
        },

    ]
};

let calendar = {
    path: '/calendar',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/calendar/',
            name: 'calendar',
            component: Calendar
        },
    ]
};


let almacen = {
    path: '/almacen',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/almacen/:idBusiness?/:pag?',
            name: 'almacen',
            component: Almacen
        },
        {
            path: '/almacen/:idBusiness/buscar/:query',
            name: 'search-almacen',
            component: Almacen
        },
        {
            path: '/historial-almacen/:idBusiness?/:pag?',
            name: 'historial-almacen',
            component: HistorialAlmacen
        },
        {
            path: '/detalle-almacen/',
            name: 'detalle-almacen',
            component: DetallesAlmacen
        },
        {
            path: '/detalle-materia-prima-almacen/',
            name: 'detalle-materia-prima-almacen',
            component: DetalleSubproductoAlmacen
        },
    ]
};

let importacion = {
    path: '/importacion',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/importacion',
            name: 'importacion',
            component: ImportacionExcels
        },
    ]
};

let novedades = {
    path: '/novedades',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/novedades',
            name: 'novedades',
            component: Novedades
        },
        {
            path: '/novedades/:id?',
            name: 'detalleNovedades',
            component: DetalleNovedades
        }
    ]
};

let integra = {
    path: '/integraciones',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/',
            name: 'integraciones',
            component: Integraciones
        },
        {
            path: '/gstock/:pag?',
            name: 'gstock',
            component: GStock
        },
        {
            path: '/gstock/buscar/:query',
            name: 'search-prducto-gs',
            component: GStock
        },
        {
            path: '/productosnorelacionados',
            name: 'productosnorelacionados',
            component: ProductosNoRelacionados
        },
        {
            path: '/productosnorelacionados/buscar/:query',
            name: 'search-prducto-pnr',
            component: ProductosNoRelacionados
        },
        {
            path: '/diagnostico-PLU',
            name: 'diagnostico-PLU',
            component: diagnosticoPLU
        },
        {
            path: '/cheerfy',
            name: 'cheerfy',
            component: Cheerfy
        },
        {
            path: '/businesscentral',
            name: 'businesscentral',
            component: BusinessCentral
        },
        {
            path: '/businesscentral/productos',
            name: 'productosbusinesscentral',
            component: ProductosBusinessCentral,
        },
        {
            path: '/businesscentral/materiasprimas',
            name: 'materiasprimasbusinesscentral',
            component: MateriasPrimasBusinessCentral,
        },
        {
            path: '/businesscentral/formas-de-pago',
            name: 'formasdepagobusinesscentral',
            component: FormasDePagoBusinessCentral,
        },
        {
            path: '/businesscentral/exportacion-ventas',
            name: 'exportacionventasbc',
            component: ExportacionVentasBusinessCentral,
        },
        {
            path: '/businesscentral/downgrades',
            name: 'downgradesbusinesscentral',
            component: DowngradesBusinessCentral,
        }
    ]
}

let log = {
    path: '/log',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/',
            name: 'log',
            component: Log
        }
    ]
}


/*let permisos = {
    path: '/permisos',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/permisos',
            name: 'permisos',
            component: Permisos
        },
    ]
};*/


let loginPage = {
    path: '/login',
    name: 'Login',
    beforeEnter: Guard.guest,
    component: Login
}

let rememberPass = {
    path: '/rememberPass',
    name: 'rememberPass',
    beforeEnter: Guard.guest,
    component: RememberPass
}

let externalLink = {
    path: '/informes/operarios/turnos-operarios-external-link/:hash',
    name: 'turnos-operarios-external-link',
    beforeEnter: Guard.guest,
    component: TurnosOperariosExternalLink,
    props: true,
}

let serverDown = {
    path: '/serverdown',
    name: 'ServerDown',
    component: ServerDown
}

let terms = {
    path: '/terms',
    name: 'Terms',
    component: Terms
}

let change = {
    path: '/configuracion',
    component: DashboardLayout,
    beforeEnter: Guard.auth,
    children: [
        {
            path: '/producto/:idBusiness/:idProducto/:idUser',
            name: 'ProductoForm',
            component: ProductoForm
        },
        {
            path: '/materias-prima/:idBusiness/:idSubproduct/:idUser',
            name: 'materiaForm',
            component: SubproductForm
        },
        {
            path: '/herramientas/gestion',
            name: 'herramientas-gestion',
            component: HerramientrasGestion
        },
        {
            path: '/herramientas/',
            name: 'herramientas',
            component: Herramientas
        },

    ]
}

// let productoFormPage = {
//     path: 'configuracion/producto/:idBusiness/:idProducto/:idUser',
//     name: 'ProductoForm',
//     component: ProductoForm
// }

// let materiaPrimaFormPage = {
//     path: '/configuracion/materias-prima/:idBusiness/:idSubproduct/:idUser',
//     name: 'materiaForm',
//     component: SubproductForm
// }

//! todo ternarios para protección por rutas.
const routes = [
    // Estado antes, lo redirige todo a cajas online que me pide auth, por lo que me lleva al login
    //{
    //    path: '/',
    //    name: 'home',
    //    redirect: '/cajas-online'
    //},

    {
        path: '/',
        name: 'home',
        redirect: (to) => {
            // Si la ruta es "turnos-operarios-external-link", no redirige
            if (to.name === 'turnos-operarios-external-link') {
                return null; // No aplica redirección
            }
            return '/cajas-online'; // Redirección por defecto
        },
    },
    {
        path: '/verifactu',
        component: DashboardLayout, // Usa el layout principal
        beforeEnter: Guard.auth, // Asegúrate de que el usuario esté autenticado
        children: [
            {
                path: '',
                name: 'verifactu',
                component: VerifactuDashboard
            },
        ]
    },
    {
        path: '/informes/operarios/turnos-operarios-external-link/:hash',
        name: 'turnos-operarios-external-link',
        component: TurnosOperariosExternalLink,
        props: true,
    },


    perfil,
    soporteOnlineMenu,
    Informes,
    //externalLink,
    Configuracion,
    loginPage,
    almacen,
    delivery,
    selfibar,
    /*camaras,*/
    calendar,
    posicionGlobal,
    gastos,
    pedidosProveedor,
    serverDown,
    gestionAlmacen,
    rememberPass,
    inventario,
    importacion,
    novedades,
    recursosClientes,
    terms,
    integra,
    log,
    change,
    // productoFormPage,
    // materiaPrimaFormPage,
    {
        path: '/cajas-online',
        beforeEnter: Guard.auth,
        component: DashboardLayout,
        children: [
            {
                path: '/',
                name: 'cajas-online',
                component: Online
            },
            {
                path: '/cajas-online/:idBusiness',
                name: 'online-detail',
                component: OnlineDetails
            },
            {
                path: '/cajas-online/tickets/:idBusiness',
                name: 'online-tickets',
                component: OnlineTickets
            },
            {
                path: '/cajas-online/productos/:idBusiness',
                name: 'online-products',
                component: OnlineProducts
            },
            {
                path: '/cajas-online/plano-mesas/:idBusiness',
                name: 'plano-mesas',
                component: Plano
            },
            {
                path: '/cajas-online/cajon-inteligente/:idBusiness',
                name: 'online-cajon-inteligente',
                component: CajonInteligente
            },
        ]
    },


    { path: '*', component: NotFound }
]



export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js